import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProductDetail } from "../services/product.service";

// Async thunk to fetch product details
export const fetchproductDetailS = createAsyncThunk(
  "productDetail/fetchproductDetailS",
  async ({ slug, sku }, { rejectWithValue }) => {
    try {
      // Call the API service
      const response = await getProductDetail(slug, sku);
      return response; // response is already the product data
    } catch (error) {
      // Return the error message for rejected state
      return rejectWithValue(
        error.response?.data?.message || error.message || "Failed to fetch product"
      );
    }
  }
);

const productDetailSlice = createSlice({
  name: "productDetail",
  initialState: {
    data: null,     // will hold the product data
    loading: false, // true when fetching
    error: null,    // holds any error messages
  },
  reducers: {
    // Clear the product data (useful on unmount)
    clearProductDetail: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchproductDetailS.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchproductDetailS.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // pass API data here
      })
      .addCase(fetchproductDetailS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearProductDetail } = productDetailSlice.actions;
export default productDetailSlice.reducer;